"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
exports.default = (dateTime, defaultZone) => {
    let { date, time, timeZone } = dateTime;
    const [year, month, day] = date.split('-').map((i) => parseInt(i, 10));
    let obj;
    if (!timeZone) {
        obj = luxon_1.DateTime.fromObject({
            year,
            month,
            day,
            zone: defaultZone,
            hour: Math.floor(time / 3600),
            minute: Math.floor((time % 3600) / 60),
            second: 0,
            millisecond: 0,
        });
    }
    else {
        obj = luxon_1.DateTime.fromObject({
            year,
            month,
            day,
            zone: timeZone,
            hour: Math.floor(time / 3600),
            minute: Math.floor((time % 3600) / 60),
            second: 0,
            millisecond: 0,
        });
        if (timeZone === 'UTC') {
            return obj.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        }
    }
    return obj;
};
